import PropTypes from 'prop-types';
import './FilterButtons.css';

// 목록 상단 필터 버튼 묶음. 선택된 버튼은 aria-pressed로 표시한다.
export default function FilterButtons({ label, options, value, onChange }) {
    return (
        <div className="admin-filter-buttons" role="group" aria-label={label}>
            {options.map(item => (
                <button key={item.key} type="button" aria-pressed={value === item.key} onClick={() => onChange(item.key)}>{item.label}</button>
            ))}
        </div>
    );
}

FilterButtons.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, label: PropTypes.string.isRequired })).isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
